import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'USER_BLACKLIST_DETAIL',
        create: 'USER_BLACKLIST_CREATE',
        update: 'USER_BLACKLIST_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        default: this.market_id,
        label: 'market_id',
        col: {
          span: 16
        },
        show: false,
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        // render: () => <d2-dict-select name="form_market_id" vModel={ this.form.model.market_id } clearable custom />
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_mobile',
        default: '',
        label: 'user_mobile',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_mobile,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: '',
        label: 'status',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "user_black_status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_type',
        default: '',
        label: 'user_type',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "black_user_type",
              "button": true
            },
            "model": {
              value: _this.form.model.user_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remarks',
        default: '',
        label: 'remarks',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "textarea",
              "autosize": true,
              "clearable": true
            },
            "model": {
              value: _this.form.model.remarks,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remarks", $$v);
              }
            }
          });
        }
      }];
    },
    market_id: function market_id() {
      return utils.cookies.get('market_id');
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  }
};